export enum LanguageEnum
{
    Arabic = 1,
    English = 2
}